module.exports = __webpack_public_path__ + "img/济源市-c.053d9315.png";